














































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class DtcpAccelerometerModuleMeasurementEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  async loadMeasurements() {
    await measurementsStoreModule.fetchAll();

    if (this.data.parent.measurements)
      return measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.data.parent.type &&
          (!this.data.parent.measurements.some((y: any) => y.measurementId == x.id) ||
            x.id === this.data.measurementId),
      );

    return [...measurementsStoreModule.entities];
  }
}
